"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var lodash_debounce_1 = __importDefault(require("lodash.debounce"));
var addPropTrackingRef_1 = __importDefault(require("./addPropTrackingRef"));
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var addDebouncedHandler = function (waitInterval, handlerPropName) {
    var _a, _b;
    var refName = '_addDebouncedHandler-ref';
    var invokeRefHandlerName = '_addDebouncedHandler-invokeRef';
    return ad_hok_1.flowMax(addPropTrackingRef_1.default(handlerPropName, refName), ad_hok_1.addHandlers((_a = {},
        _a[invokeRefHandlerName] = function (_a) {
            var _b = refName, handlerRef = _a[_b];
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return handlerRef.current.apply(handlerRef, args);
            };
        },
        _a), []), ad_hok_1.addHandlers((_b = {},
        _b[handlerPropName] = function (_a) {
            var _b = invokeRefHandlerName, invokeRefHandler = _a[_b];
            return lodash_debounce_1.default(invokeRefHandler, waitInterval);
        },
        _b), []), cleanupProps_1.default([refName, invokeRefHandlerName]));
};
exports.default = addDebouncedHandler;
